"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var splitPaths = function splitPaths(paths, size) {
  return paths.map(function (path, i) {
    return i % size === 0 ? paths.slice(i, i + size) : null;
  }).filter(function (e) {
    return e;
  });
};

exports.default = splitPaths;